import { Component, Inject } from '@angular/core';
import { ReactiveFormsModule, UntypedFormBuilder, UntypedFormControl, Validators } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { MatError, MatFormField, MatLabel } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-add-phone-dlg',
  templateUrl: './add-phone-dlg.component.html',
  standalone: true,
  imports: [TranslatePipe, MatLabel, MatIcon, MatFormField, MatDialogClose, MatButton, MatDialogActions, MatDialogContent, MatDialogTitle, MatInput, ReactiveFormsModule, MatError],
})
export class AddPhoneDlgComponent {
  phoneFormControl = new UntypedFormControl('', [Validators.required, Validators.maxLength(20)]);

  constructor(
    public dialogRef: MatDialogRef<AddPhoneDlgComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    readonly formBuilder: UntypedFormBuilder,
  ) {}

  formControlHasErrors() {
    return this.phoneFormControl.hasError('required') || this.phoneFormControl.hasError('maxlength');
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
